import * as React from 'react';
import { Button } from 'react-bootstrap';

interface Props {
  id: string;
  sortKey: string;
  onSort: (order: 'asc' | 'desc' | '') => void;
}

type sortOrder = 'asc' | 'desc' | '';
export default function SortComponent(props: Props) {
  const [order, setOrder] = React.useState<sortOrder>('');

  React.useEffect(() => {
    if (props.sortKey !== props.id) {
      setOrder('');
    }
  }, [props.sortKey]);
  const sort = () => {
    const o = order === '' ? 'desc' : order === 'desc' ? 'asc' : '';
    setOrder(o);
    props.onSort(o);
  };

  return (
    <span className="ms-2">
      <Button
        size="sm" variant={order === '' ? 'light' : 'primary'}
        onClick={() => sort()}
      >
        <i className={`fa fa-sort${order !== '' ? `-numeric-${order}` : ''}`}/>
      </Button>
    </span>
  );
}

